import JSDB from 'fromKotlin/nk';
import { whatsappRefresh } from '../api/customer/documents.api';
import type { WhatsAppConfig } from './useWhatsAppConfig';
import { isWhatsAppServerSkipConnectionCheck } from './useWhatsAppConfig';

export { isWhatsAppServerSkipConnectionCheck };

/** Same health check as ConnectionIndicators (new API: POST /health, legacy: whatsappRefresh). */
export async function fetchWhatsAppConnected(waConfig: WhatsAppConfig): Promise<boolean> {
    if (!waConfig) return false;

    if (isWhatsAppServerSkipConnectionCheck(waConfig.server)) {
        return true;
    }

    if (waConfig.isNewApi) {
        try {
            const res = await fetch(`${waConfig.baseUrl}/health`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-api-key': waConfig.token },
                body: JSON.stringify({ instance_id: waConfig.instanceId }),
            });
            const data = await res.json();
            return data?.connected === true;
        } catch {
            return false;
        }
    }

    try {
        const result = await whatsappRefresh(JSDB().currentAgent);
        return result === true;
    } catch {
        return false;
    }
}
